import Layout from "@/components/layout/layout";
import StaffGameSettings from "../components/mini-game/manage-setting-game";

const ManageSettingGamePage = () => {
  return (
    <div>
      <Layout>
        <StaffGameSettings />
      </Layout>
    </div>
  );
};

export default ManageSettingGamePage;
